import { Redirect } from '#app/components/Redirect/index.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { useNavigation } from '#app/hooks/useNavigation.js';
import { useCurrentUserPortfolioLink } from '#app/hooks/usePortfolioLink.js';
import { appendSearch } from '#app/utilities/appendSearch.js';
import { useMount } from '@contra/react-hooks/useMount';
import { parse } from '@contra/utilities/queryString';

// Used to redirect a user to their own portfolio
export const Page = () => {
  const currentUser = useCurrentUser();
  const { getPortfolioLinkProps } = useCurrentUserPortfolioLink();
  const { pathname, search } = useLocation();
  const { href } = getPortfolioLinkProps({
    urlParameters: {
      utm_campaign: 'independent_portfolio_redirect',
      ...parse(search),
    },
  });

  const navigation = useNavigation();

  useMount(() => {
    if (currentUser && href) {
      navigation.push(href);
    }
  });

  if (currentUser === null) {
    return (
      <Redirect
        method="replace"
        to={appendSearch(pathname.replace(/^\/portfolio/, '/log-in'), {
          redirectTo: appendSearch('/portfolio', parse(search)),
        })}
      />
    );
  }

  return null;
};
